import sessionStorage from "sessionstorage";
import localForage from "localforage";
import axios from "axios";
import { UiPaths } from "../../UiPaths";
import {
  SESSION_EXPIRED,
  SESSION_EXPIRED_MSG,
  UNAUTHORIZED,
  UNAUTHORIZED_MSG,
} from "../../Constants";

let isLoggingOut = false;

/**
 * Checks if the API response or error payload indicates session expiration or unauthorized access.
 * Matches:
 * {"statusCode":-1,"errorCode":-104003,"errorMessage":"Your session has expired!"}
 * or errorCode === SESSION_EXPIRED (-104003)
 * or errorCode === UNAUTHORIZED (-109002)
 */
export const isSessionExpiredResponse = (resOrErr) => {
  if (!resOrErr) return false;
  const data = resOrErr.data || resOrErr.response?.data || resOrErr;
  if (!data || typeof data !== "object") return false;

  const errorCode =
    data.errorCode !== undefined && data.errorCode !== null
      ? Number(data.errorCode)
      : undefined;
  const statusCode =
    data.statusCode !== undefined && data.statusCode !== null
      ? Number(data.statusCode)
      : undefined;
  const errorMsg =
    typeof data.errorMessage === "string" ? data.errorMessage.trim() : "";

  return (
    errorCode === SESSION_EXPIRED ||
    errorCode === -104003 ||
    errorCode === UNAUTHORIZED ||
    errorCode === -109002 ||
    errorMsg.toLowerCase().includes("session has expired") ||
    (statusCode === -1 &&
      (errorCode === -104003 ||
        errorMsg.toLowerCase().includes("session has expired")))
  );
};

/**
 * Performs auto logout: alerts the user, clears session storage and local cache,
 * and redirects to the login / home screen.
 */
export const handleSessionExpired = (resOrErr) => {
  if (isLoggingOut) return;
  isLoggingOut = true;

  const data = resOrErr?.data || resOrErr?.response?.data || resOrErr || {};
  const errorCode =
    data.errorCode !== undefined && data.errorCode !== null
      ? Number(data.errorCode)
      : undefined;
  const errorMsg =
    typeof data.errorMessage === "string" ? data.errorMessage.trim() : "";

  let msg = SESSION_EXPIRED_MSG;
  if (errorCode === UNAUTHORIZED || errorCode === -109002) {
    msg = UNAUTHORIZED_MSG;
  } else if (errorMsg) {
    msg = errorMsg;
  }

  alert(msg);

  try {
    localForage.removeItem("heads");
  } catch (e) {}

  try {
    sessionStorage.removeItem("sessionItem");
    sessionStorage.removeItem("screenLogs");
    sessionStorage.removeItem("loginItem");
    sessionStorage.clear();
  } catch (e) {}

  try {
    localStorage.clear();
  } catch (e) {}

  window.location.href = UiPaths.HOME;
};

let interceptorSetup = false;

/**
 * Installs a global Axios response interceptor that catches any session expired response.
 */
export const setupSessionInterceptor = () => {
  if (interceptorSetup) return;
  interceptorSetup = true;

  axios.interceptors.response.use(
    (response) => {
      if (isSessionExpiredResponse(response)) {
        handleSessionExpired(response);
      }
      return response;
    },
    (error) => {
      if (isSessionExpiredResponse(error)) {
        handleSessionExpired(error);
      }
      return Promise.reject(error);
    }
  );
};
